import { Container } from './MiniAppLogo.styles'

export default function MiniAppLogo() {
  return (
    <Container>
      Mini App
    </Container>
  )
}
